<template>
  <div class="expense-page">
    <Header />
    <main class="app-content">
      <div class="app-title">
        <div>
          <h1 class="page-title"><i class="fa fa-dashboard"></i> GİDER KAYIT EKRANI</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#">GİDER KAYIT EKRANI</a></li>
        </ul>
      </div>

      <div class="row form-margin justify-content-center">
        <div class="col-lg-9 col-md-10">
          <div class="tile card-elevated">
            <div class="tile-header">
              <h3 class="tile-title">GİDER KAYIT EKRANI</h3>
            </div>

            <div class="tile-body">
              <form @submit.prevent="sendData">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label class="control-label">Gider Girilecek Sahayı Seçiniz</label>
                    <select class="form-control custom-select" @change="getBySaha($event)">
                      <option value="" disabled selected>SAHA SEÇİNİZ</option>
                      <option
                        v-for="saha in sahalar"
                        :value="saha.id"
                        :key="saha.id"
                        v-if="saha.status == 0 || saha.status == 3"
                      >{{ saha.id }} - {{ saha.sahaName }}</option>
                    </select>
                  </div>

                  <div class="form-group col-md-6">
                    <label class="control-label">Gider Başlığını Seçiniz</label>
                    <select class="form-control custom-select" @change="getByCategory($event)">
                      <option value="" disabled selected>Kategori Seçiniz</option>
                      <option v-for="category in categories" :value="category.id" :key="category.id">
                        {{ category.category_name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-6">
                    <label class="control-label">Personel Seçiniz</label>
                    <select class="form-control custom-select" @change="getByPersonel($event)">
                      <option value="" disabled selected>Personel Seçiniz</option>
                      <option v-for="personel in personeller" :value="personel.id" :key="personel.id">
                        {{ personel.name }} {{ personel.surname }}
                      </option>
                    </select>
                  </div>

                  <div class="form-group col-md-6">
                    <label class="control-label">Makina Seçiniz</label>
                    <select class="form-control custom-select" @change="changemakina($event)">
                      <option value="" disabled selected>MAKİNA SEÇİNİZ</option>
                      <option v-for="machine in machines" :value="machine.id" :key="machine.id">
                        {{ machine.makina_code + ' ' + machine.makina_name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="form-row align-items-end">
                  <div class="form-group col-md-4">
                    <label class="control-label">Girilen Tutar</label>
                    <input
                      v-model="baseAmountInput"
                      @input="onBaseAmountInput"
                      class="form-control input-lg"
                      type="number"
                      step="0.01"
                      placeholder="0.00"
                    />
                    <small class="form-text text-muted">Girilen değer KDV dahil veya hariç olabilir</small>
                  </div>

                  <div class="form-group col-md-4">
                    <label class="control-label">KDV dahil mi?</label>
                    <div class="d-flex gap-3">
                      <label class="radio-inline nicer-radio">
                        <input type="radio" name="kdvIncluded" :value="true" v-model="kdvIncluded" @change="onBaseAmountInput" /> Evet
                      </label>
                      <label class="radio-inline nicer-radio">
                        <input type="radio" name="kdvIncluded" :value="false" v-model="kdvIncluded" @change="onBaseAmountInput" /> Hayır
                      </label>
                    </div>
                  </div>

                  <div class="form-group col-md-4">
                    <label class="control-label">KDV Oranı</label>
                    <div class="kdv-options">
                      <label class="kdv-chip" :class="{ active: kdvRate === 0 }">
                        <input type="radio" name="kdv" :value="0" v-model.number="kdvRate" @change="onBaseAmountInput" /> %0
                      </label>
                      <label class="kdv-chip" :class="{ active: kdvRate === 0.01 }">
                        <input type="radio" name="kdv" :value="0.01" v-model.number="kdvRate" @change="onBaseAmountInput" /> %1
                      </label>
                      <label class="kdv-chip" :class="{ active: kdvRate === 0.10 }">
                        <input type="radio" name="kdv" :value="0.10" v-model.number="kdvRate" @change="onBaseAmountInput" /> %10
                      </label>
                      <label class="kdv-chip" :class="{ active: kdvRate === 0.20 }">
                        <input type="radio" name="kdv" :value="0.20" v-model.number="kdvRate" @change="onBaseAmountInput" /> %20
                      </label>
                    </div>
                  </div>
                </div>

                <hr class="divider" />

                <div class="calc-panel">
                  <div class="calc-item">
                    <label class="calc-label">KDV Tutarı</label>
                    <div class="calc-value highlight"> {{ outputValue || '0.00' }} TL </div>
                  </div>

                  <div class="calc-item">
                    <label class="calc-label">KDV Hariç (Baz)</label>
                    <div class="calc-value">{{ baseAmountComputed || '0.00' }} TL</div>
                  </div>

                  <div class="calc-item">
                    <label class="calc-label">Toplam (KDV Dahil)</label>
                    <div class="calc-value highlight-primary">{{ gidertutari || '0.00' }} TL</div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label class="control-label">Harcama Tarihi</label>
                    <input
                      v-model="gidertarihi"
                      type="date"
                      id="start"
                      name="trip-start"
                      min="2023-09-27"
                      max="2030-12-31"
                      class="form-control"
                    />
                  </div>

                  <div class="form-group col-md-8">
                    <label class="control-label">Açıklama</label>
                    <input v-model="aciklamaone" class="form-control" type="text" placeholder="Açıklama" />
                  </div>
                </div>

                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label class="control-label">Açıklama 2</label>
                    <input v-model="aciklamatwo" class="form-control" type="text" placeholder="Açıklama 2" />
                  </div>
                </div>

                <div class="tile-footer d-flex justify-content-end">
                  <button class="btn btn-danger btn-save" type="submit">
                    <i class="fa fa-fw fa-lg fa-check-circle"></i> Kaydet
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      sahalar: [],
      machines: [],
      categories: [],
      personeller: [],
      gidertutari: "",
      gidertarihi: "",
      aciklamaone: "",
      aciklamatwo: "",
      makineId: "",
      kdvRate: 0.20,
      outputValue: "",
      baseAmountInput: "",
      baseAmountComputed: "",
      kdvIncluded: true,
      saha_id: null,
      category_id: null,
      personel_id: null,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    var token = localStorage.getItem("token");
    if (!token) {
      this.$router.push("/");
    }
    var url = store.state.base_url + "AslanSahalar/getAllSahaDropUpdate.php?key=123";
    axios.post(url).then((response) => { this.sahalar = response.data; }).catch((err) => console.log(err.response));
    var url2 = store.state.base_url + "AslanSahalar/getAllCategories.php?key=123";
    axios.post(url2).then((response2) => { this.categories = response2.data; }).catch((err) => console.log(err.response));
    var url7 = store.state.base_url + "AslanSahalar/getAllMakinaFilter.php?key=123";
    axios.post(url7).then((response) => { this.machines = response.data; }).catch((err) => console.log(err.response));
    var url3 = store.state.base_url + "AslanSahalar/getAllPersonelStatus.php?key=123";
    axios.post(url3).then((response3) => { this.personeller = response3.data; }).catch((err) => console.log(err.response));
    if (this.baseAmountInput) this.onBaseAmountInput();
  },
  methods: {
    changemakina(event) { this.makineId = event.target.value; },
    getBySaha(event) { this.saha_id = event.target.value; },
    getByCategory(event) { this.category_id = event.target.value; },
    getByPersonel(event) { this.personel_id = event.target.value; },
    reload() { location.reload(); },

    onBaseAmountInput() {
      if (this.baseAmountInput === "" || this.baseAmountInput === null) {
        this.outputValue = ""; this.gidertutari = ""; this.baseAmountComputed = ""; return;
      }
      const entered = parseFloat(this.baseAmountInput);
      if (isNaN(entered)) { this.outputValue = ""; this.gidertutari = ""; this.baseAmountComputed = ""; return; }

      if (this.kdvIncluded) {
        const baz = entered / (1 + this.kdvRate);
        const kdvTutar = entered - baz;
        const toplam = entered;
        this.baseAmountComputed = baz.toFixed(2);
        this.outputValue = kdvTutar.toFixed(2);
        this.gidertutari = toplam.toFixed(2);
      } else {
        const baz = entered;
        const kdvTutar = baz * this.kdvRate;
        const toplam = baz + kdvTutar;
        this.baseAmountComputed = baz.toFixed(2);
        this.outputValue = kdvTutar.toFixed(2);
        this.gidertutari = toplam.toFixed(2);
      }
    },

    sendData() {
      if (this.gidertarihi == "") {
        this.$swal({ text: "GİDER TARİHİNİ GİRİNİZ!", icon: "error", closeOnClickOutside: false }); return;
      }
      if (this.gidertutari == "") {
        this.$swal({ text: "GİDER TUTARINI GİRİNİZ!", icon: "error", closeOnClickOutside: false }); return;
      }
      var url = store.state.base_url + "AslanSahalar/createGider.php?key=123";
      var datas = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        gidertutari: this.baseAmountComputed,
        gidertarihi: this.gidertarihi,
        category_id: this.category_id,
        saha_id: this.saha_id,
        aciklamaone: this.aciklamaone,
        aciklamatwo: this.aciklamatwo,
        personel_id: this.personel_id,
        makineId: this.makineId,
        kdvRate: this.kdvRate,
        baseAmountInput: this.baseAmountInput,
        baseAmountComputed: this.baseAmountComputed,
        kdvIncluded: this.kdvIncluded
      };
      axios.post(url, JSON.stringify(datas)).then((response) => {
        if (response.data.data == true) {
          this.$swal({ text: "Kayıt İşleminiz Başarıyla Gerçekleştirildi!", icon: "success", closeOnClickOutside: true });
        } else {
          this.$swal({ text: "Hata Oluştu Admine DanışIN!", icon: "error", closeOnClickOutside: false });
        }
      }).catch((error) => { console.log(error.response); });
    },
  },

  components: { Header, Sidebar },
};
</script>

<style scoped>
/* Genel düzen ve kart stili */
.card-elevated {
  background: #ffffff;
  border-radius: 8px;
  padding: 18px;
  box-shadow: 0 8px 20px rgba(20, 30, 50, 0.08);
  border: 1px solid rgba(20,30,50,0.04);
}
.page-title { font-size: 20px; font-weight: 600; margin: 0 0 8px; color: #0b3b66; }
.tile-header { border-bottom: 1px solid #eef3f8; margin-bottom: 12px; padding-bottom: 8px; }
.tile-title { margin: 0; font-size: 16px; color: #223344; }

/* Form alanları */
.form-control { height: 44px; border-radius: 6px; border: 1px solid #d8e2ef; }
.input-lg { padding: 10px 12px; font-size: 15px; }

/* KDV seçenekleri görsel çipler */
.kdv-options { display: flex; gap: 8px; align-items: center; flex-wrap: wrap; margin-top: 6px; }
.kdv-chip {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 62px; height: 36px; border-radius: 8px; border: 1px solid #e6eef8;
  background: #fafcff; color: #0b3b66; font-weight: 600; cursor: pointer;
  transition: all 0.12s ease;
  padding: 0 8px;
}
.kdv-chip input { margin-right: 8px; transform: scale(1.0); }
.kdv-chip.active { background: #0b69d8; color: #fff; border-color: #0b69d8; }

/* Radio butonlar */
.nicer-radio input { margin-right: 8px; transform: scale(1.02); }
.radio-inline { margin-right: 12px; color: #334b63; font-weight: 600; }

/* Hesap paneli */
.calc-panel { display: flex; gap: 12px; margin: 14px 0; flex-wrap: wrap; }
.calc-item { flex: 1 1 30%; min-width: 180px; background: #f7fbff; border-radius: 8px; padding: 12px; border: 1px solid #eef6ff; }
.calc-label { display: block; font-size: 13px; color: #5b6b7a; margin-bottom: 6px; }
.calc-value { font-size: 16px; font-weight: 700; color: #223344; }
.highlight { background: #fff; padding: 8px 10px; border-radius: 6px; border: 1px dashed rgba(11,105,216,0.12); display: inline-block; }
.highlight-primary { background: linear-gradient(90deg,#eaf3ff,#f7fbff); color:#0b69d8; padding:8px 10px; border-radius:6px; font-weight:800; }

/* Footer buton */
.tile-footer { margin-top: 12px; padding-top: 8px; border-top: none; }
.btn-save { padding: 10px 18px; border-radius: 8px; background: #d9302c; border: none; color: #fff; font-weight: 600; box-shadow: 0 6px 14px rgba(217,48,44,0.12); }
.btn-save:hover { background: #c42722; transform: translateY(-1px); }

/* Responsive */
@media (max-width: 767px) {
  .calc-item { flex: 1 1 100%; }
  .kdv-options { gap: 6px; }
}
</style>



// WEBPACK FOOTER //
// src/components/GiderKayit.vue